module.exports = __webpack_public_path__ + "static/media/customer-service.b9ba60cf.png";